import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { Button, Icon } from '@material-ui/core';

import moment from 'moment';
import { auth } from '../../firebase';


import mayBeIcon from '../../images/information.png';
import yesIcon from '../../images/checked.png';
import noIcon from '../../images/error.png';

const styles = theme => ({
    title: {
        paddingLeft: '80px',
        paddingRight: '80px',
        paddingTop: '35px',
    },
    card: {
        marginTop: "10px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#fff"
    },
    cardHover: {
        marginTop: "30px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#AAA"
    },
    cardAvatar: {
        maxWidth: "130px",
        maxHeight: "130px",
        borderRadius: "50%",
        overflow: "hidden",
        boxShadow:
            "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },

    textAlign: {
        textAlign: "center"
    },
    cardSubtitle: {
        color: "#999",
        fontSize: "1em",
        textTransform: "uppercase",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardTitle: {
        fontSize: "1.3em",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardDescription: {
        padding: "5px 10px",
    },
    cardActions: {
        height: "auto",
        display: "inline"
    }
});

class Invite extends Component {
    constructor(props) {
        super(props);

        
        this.state = {
            event: props.location.data.event
        };

        console.log(this.state.event)
    }

    render() {
        const { classes } = this.props;

        let imageSection 
        if (this.state.event.images) {
            imageSection = (
                this.state.event.images.map(value => (
                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <img style={{ height: '200px', width: '80%' }} alt='EVENT-IMG' src={value.url} />
                    </Grid>
                ))
            )
        }

        return (
            <div style={{ padding: '40px' }}>
                <Card onClick={() => this.setState({ updateRequest: true })} className={classes.card} >
                    <CardContent>
                        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid spacing={0} container item xs={12} sm={8} md={9} lg={9} xl={9} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <Typography variant='title' className={classes.cardDescription}>
                                        {this.state.event.eventName}
                                    </Typography>
                                    <Typography component="p" className={classes.cardDescription}>
                                        {this.state.event.date}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <Typography component="p" className={classes.cardDescription}>
                                        {this.state.event.location}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card >

                <Typography component="p" className={classes.cardDescription}>
                    {this.state.event.description}
                </Typography>

                {imageSection}

                <Grid spacing={0} container style={{ paddingTop:'20px' }}>
                    <Grid item xs={2}>
                        RSVP status:{"                    "}
                    </Grid>
                    <Grid item xs={1}>    
                        {this.state.event.rsvpStatus === 0 && <img src={yesIcon} height={30} width={30} alt='YES' />}
                        {this.state.event.rsvpStatus === 1 && <img src={noIcon} height={30} width={30} alt='NO' />}
                        {(this.state.event.rsvpStatus === 2 || this.state.event.rsvpStatus === undefined) && <img src={mayBeIcon} height={30} width={30} alt='Maybe' />}
                    </Grid>
                    <Grid item>
                        {!moment(this.state.event.date, 'MM/DD/YYYY').isBefore() && 
                        <Link to={"/rsvp/" + this.state.event.eventId + '_' + auth.currentUser.email} style={{ textDecoration: 'none' }}>
                            <Button mini variant="fab" color="secondary" aria-label="edit">
                                <Icon>edit_icon</Icon>
                            </Button>
                        </Link> 
                    }
                    </Grid>
                </Grid>

                <div style={{ marginTop:'20px' }} >
                    {this.state.event.amount > 0 && 'You contributed : $' +  this.state.event.amount}
                    {this.state.event.amount === 0 &&
                        <Link to={"/donate/" + this.state.event.eventId + '_' + auth.currentUser.email} style={{ textDecoration: 'none' }}>
                            <Button variant="outlined">CONTRIBUTE</Button>
                        </Link>
                    }
                </div>
            </div>
        );
    }
}

Invite.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Invite);



// WEBPACK FOOTER //
// ./src/components/Invites/Invite.js